
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/activate_gift_cards",
      function () {
        return require("private-next-pages/[locale]/activate_gift_cards/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/activate_gift_cards"])
      });
    }
  